<template>
    <div style="width: 1024px;margin: auto;">
        <el-container style="width: 1024px;margin: auto;margin-top:50px;">
            <el-header>
                <div @click="$router.back()">
                    <img src="./img/icon.png" style="height:40px;margin-left: 0px;" />
                </div>
            </el-header>
            <el-main>
                <avue-crud ref="crud" v-if="config" :option="config.option" :data="config.data"
                    :page.sync="config.pager" :table-loading="config.loading" @row-del="config.onRowDel"
                    @row-save="config.onRowSave" @row-update="config.onRowUpdate" @refresh-change="config.refresh"
                    @search-change="config.onSearchChange" @current-change="config.refresh"
                    @size-change="config.refresh" @filter="config.onFilterChange" @date-change="config.onDateChange"
                    @sort-change="config.onSortChange" @selection-change="config.onSelectionChange">
                </avue-crud>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import { init } from './api/api_utils'
import { getUser } from './api/user'
export default {
    name: "user-manager",
    data() {
        return {
            config: null
        };
    },
    async created() {
        let user = await getUser();
        console.log(user);
        if (user.level > 0) {
            this.$message({
                message: "您当前没有权限！",
                type: 'error'
            });
        }
        else {
            this.config = await init({
                option_id: 1,
                app_name: "auth",
                model_name: "user",
            });
        }
    },
    mounted() {
    },
    methods: {
    },
};
</script>
  
<style >
body,
html,
#app {
    height: 100%;
}

.avue-crud .el-card {
    background-color: transparent;
}

.avue-crud .el-collapse-item__wrap {
    background-color: transparent;
}

.avue-crud .avue-crud__menu {
    background-color: transparent;
}
</style>
  
  